/* eslint-disable react/prop-types */
import React from 'react';
import FlyAshChallanDetailModal from './FlyAshChallanDetailModal';
import CoalIronOreChallanDetailModal from './CoalIronOreChallanDetailModal';

const ShowChallanDetail = ({ trans_for, challan_no, show, handleClose }) => {
  if (show) {
    if (trans_for === 'Fly Ash') {
      return (
        <FlyAshChallanDetailModal
          show={show}
          handleClose={handleClose}
          challan_no={challan_no}
        />
      );
    } else {
      return (
        <CoalIronOreChallanDetailModal
          show={show}
          handleClose={handleClose}
          challan_no={challan_no}
        />
      );
    }
  }
  return null;
};

export default ShowChallanDetail;
